import script from "./WoononSubtotalWidget.vue?vue&type=script&lang=ts&setup=true"
export * from "./WoononSubtotalWidget.vue?vue&type=script&lang=ts&setup=true"

import "./WoononSubtotalWidget.vue?vue&type=style&index=0&id=58271f82&lang=less&scoped=true"

import exportComponent from "/var/build/production/buyers-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58271f82"]])

export default __exports__